module.exports = __webpack_public_path__ + "static/media/katieWebber.580da324.jpg";